import consts from '../consts/const';
import { encodeStory, hasStory } from '../utils/story'
import { saveBlock, clearBlock } from '../utils/blockNotice'
export const SING_UP = 'SING_UP';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';

const seveAuthData = (id,pid) =>{
localStorage.setItem('userdata',JSON.stringify({id:id,pid:pid}))
}

export const log_out = () =>{
  return dispatch =>{
    localStorage.removeItem('userdata')
    dispatch({type:LOG_OUT})
  }
}

export const sing_up = (email,password,name,gmail) =>{
  return async dispatch =>{
    const res = await fetch(`/api/auth/singup`,{
      method:'POST',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({email,password,name,gmail})
    })
    const ress = await res.json();
console.log(ress);
if(ress.msg && ress.msg.code === 'ER_DUP_ENTRY'){throw 'email name is taken';}
    dispatch({type:SING_UP,id:ress.msg2,pid:ress.msg2})
      seveAuthData(ress.msg,ress.msg2);
  }
}

export const complete_signup = (email,password,name,img,bio,country) =>{
  return async dispatch =>{
    const gmail = String(email).slice(0, 80);
    const res = await fetch(`/api/auth/singup`,{
      method:'POST',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({email,password,name,gmail})
    })
    const ress = await res.json().catch(() => ({}));
    const dbCode = ress.msg && typeof ress.msg === 'object' ? ress.msg.code : '';
    if(dbCode === 'ER_DUP_ENTRY' || /taken/i.test(String(ress.error || ''))){
      throw new Error('email is taken');
    }
    if(!ress.msg2){
      throw new Error(ress.error || (dbCode === 'PROTOCOL_SEQUENCE_TIMEOUT' || dbCode === 'ER_USER_LIMIT_REACHED' || dbCode === 'PROTOCOL_CONNECTION_LOST'
        ? 'Database is busy. Wait a minute and try again.'
        : 'Could not create account'));
    }
    const pid = ress.msg2;
    const id = ress.msg;
    seveAuthData(id, pid);
    const bioText = String(bio || '').trim();
    const countryText = country && country !== 'Select country' ? String(country) : '';
    await fetch(`/api/auth/${pid}`,{
      method:'PATCH',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({
        email,
        password,
        name,
        story:'',
        cardId:'',
        job:'',
        hobby:'',
        country: countryText,
        bio: bioText,
        age:0,
        img: img || '',
        big_img:''
      })
    })
    dispatch({
      type:LOG_IN,
      id,
      pid,
      userData:{
        email,
        postion: countryText,
        job:'',
        hobby:'',
        photo:img || '',
        bio: bioText,
        name,
        age:0,
        story:'',
        big_img:'',
        password,
        follow:0,
        followers:0
      }
    })
  }
}

export const log_in = (email,password) =>{
  return async dispatch =>{
    const res = await fetch(`/api/auth/login`,{
      method:'POST',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({email,password})
    })
    const resst = await res.json();

if(resst.msg === 'blocked'){
  saveBlock(resst)
  throw new Error(resst.text || 'You are blocked')
}
if(resst.msg === 'user are not in'){throw resst.msg;}

  const ress = resst.msg[0];
dispatch({type:LOG_IN,id:ress.privet_id,userData:{email:ress.email,postion:ress.country,job:ress.job,hobby:ress.hobby}})
    seveAuthData(ress.id,ress.privet_id);
  }
}

export const auth = (id,pid) =>{
  return async dispatch =>{
    const res = await fetch(`/api/auth/auth`,{
      method:'POST',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({id,pid})
    })
    const ress = await res.json();
    if (ress.msg === 'blocked') {
      saveBlock(ress)
      throw new Error(ress.text || 'You are blocked')
    }
    if (!ress.msg || !ress.msg[0]) throw new Error('Could not load profile');
    const user = ress.msg[0];
    clearBlock()
    seveAuthData(user.id, pid);
    let story = user.story || ''
    if (story && !hasStory(story)) {
      story = ''
      fetch(`/api/auth/story/${pid}`, {
        method: 'PATCH',
        headers: { 'content-Type': 'application/json' },
        body: JSON.stringify({ story: '' })
      }).catch(() => {})
    }
dispatch({type:LOG_IN,id:user.id,pid:pid,userData:{email:user.email,postion:user.country,job:user.job,hobby:user.hobby,photo:user.img,bio:user.bio,age:user.age,name:user.first_name,story,big_img:user.big_img,follow:ress.following,followers:ress.leading}})
}}

export const update = (email,country,job,hobby,img,big_img,name,password,story,bio,age) =>{
  return async (dispatch,getState) =>{
    const pid = getState().authReduse.pid;
    const id = getState().authReduse.id;
    const current = getState().authReduse;
    const res = await fetch(`/api/auth/${pid}`,{
      method:'PATCH',
      headers:{'content-Type':'application/json'},
      body:JSON.stringify({email,country,job,hobby,img,big_img,name,password,story,bio,age})
    })
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      const first = body && body.msg && body.msg.errors && body.msg.errors[0] && body.msg.errors[0].msg
      throw new Error(first || body.error || 'Could not save settings')
    }
    dispatch({type:LOG_IN,id:id,pid:pid,userData:{
      email,
      postion:country,
      job,
      hobby,
      photo:img,
      bio,
      age: body.age != null ? body.age : age,
      name,
      story,
      big_img,
      password: password || current.password,
      follow:current.follow,
      followers:current.followers
    }})
  }
}

export const send_code = async (email) => {
  let res
  try {
    res = await fetch('/api/auth/verify/send', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ email })
    })
  } catch (err) {
    throw new Error('Could not reach the server. Try again.')
  }
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || 'Could not send the code')
  return body
}

export const check_code = async (email, code) => {
  const res = await fetch('/api/auth/verify/check', {
    method: 'POST',
    headers: { 'content-Type': 'application/json' },
    body: JSON.stringify({ email, code })
  })
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || 'Wrong code')
  return body
}

export const social_ticket = async (ticket) => {
  const res = await fetch('/api/auth/social/ticket', {
    method: 'POST',
    headers: { 'content-Type': 'application/json' },
    body: JSON.stringify({ ticket })
  })
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || 'Sign in expired. Try again')
  return body
}

export const google_in = (payload) => {
  return async dispatch => {
    const res = await fetch('/api/auth/google', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    const body = await res.json().catch(() => ({}))
    if (body.msg === 'blocked') {
      saveBlock(body)
      throw new Error(body.text || 'You are blocked')
    }
    if (!res.ok) throw new Error(body.error || 'Google sign in failed')
    if (body.id && body.pid) {
      seveAuthData(body.id, body.pid)
      await dispatch(auth(body.id, body.pid))
      return { ok: true }
    }
    return { signup: true, email: body.email, name: body.name, password: body.password }
  }
}

export const update_story = (story) => {
  return async (dispatch, getState) => {
    const current = getState().authReduse;
    const pid = current.pid;
    if (!pid) throw new Error('Not signed in');
    const packed = story ? encodeStory(story) : '';
    const res = await fetch(`/api/auth/story/${pid}`, {
      method: 'PATCH',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ story: packed })
    });
    if (!res.ok) throw new Error('Could not save story');
    dispatch({
      type: LOG_IN,
      id: current.id,
      pid,
      userData: {
        email: current.email,
        postion: current.postion,
        job: current.job,
        hobby: current.hobby,
        photo: current.photo,
        bio: current.bio,
        age: current.age,
        name: current.name,
        story: packed,
        big_img: current.big_img,
        password: current.password,
        follow: current.follow,
        followers: current.followers
      }
    });
  }
}
